// extracted by mini-css-extract-plugin
export default {"legend-item":"EstimateBubble_legend-item__6eoY6","legend-line-title":"EstimateBubble_legend-line-title__HVM3h"};